import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const CloseSmall = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            d="M14.8536 8.19601L11.9963 11.0533L9.14642 8.20344C8.88506 7.94208 8.45738 7.94208 8.19602 8.20344C7.93466 8.4648 7.93466 8.89248 8.19602 9.15384L11.0459 12.0037L8.20344 14.8462C7.94208 15.1075 7.94209 15.5352 8.20344 15.7966C8.4648 16.0579 8.89248 16.0579 9.15384 15.7966L11.9963 12.9541L14.8461 15.804C15.1075 16.0653 15.5352 16.0653 15.7965 15.804C16.0579 15.5426 16.0579 15.1149 15.7965 14.8536L12.9467 12.0037L15.804 9.14643C16.0653 8.88507 16.0653 8.45739 15.804 8.19603C15.5426 7.93467 15.1149 7.93465 14.8536 8.19601Z"
            fill={color}
        />
    </StarryUIIcon>
);
